export const LEGAL_POLICY_TYPE_OPTIONS = [
  { value: 'data_treatment', label: 'Tratamiento de datos' },
] as const;

export function legalPolicyTypeLabel(type: string): string {
  const match = LEGAL_POLICY_TYPE_OPTIONS.find((item) => item.value === type);
  return match?.label ?? type;
}
